{text}

<script lang="ts">
  export let count
  export let when
  $: text = when[String(count)] || when.other
</script>
